export default {
  confirmLabel: 'ç¡®å®',
  backspaceLabel: 'éæ ¼',
  cancelKeyboardLabel: 'æ¶èµ·é®ç',
};
